import { render, staticRenderFns } from "./StatisticsTradeTransactions.vue?vue&type=template&id=61afe955&"
import script from "./StatisticsTradeTransactions.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradeTransactions.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTradeTransactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports